import PropTypes from 'prop-types';
import React from 'react';

import FeedImportInProgress from "./components/FeedImportInProgress";
import DeleteFeedButton from "./components/DeleteFeedButton";
import EditFeedButton from "./components/EditFeedButton";
import HistoryFeedButton from "./components/HistoryFeedButton";
import ImportButton from "./components/ImportButton";
import ForceImportButton from "./components/ForceImportButton";
import MapperButton from "./components/MapperButton";

FeedActions.propTypes = {
    feed: PropTypes.shape({
        id: PropTypes.string.isRequired,
        '@id': PropTypes.string.isRequired,
        dataType: PropTypes.string.isRequired,
        transportType: PropTypes.string.isRequired,
        mapper: PropTypes.string,
        configuration: PropTypes.object,
    }).isRequired,
};

function FeedActions({feed}) {
    if (feed.process !== 'idle') {
        return (
           <FeedImportInProgress feed={feed} />
        )
    }

    return (
        <div style={{display: 'flex', justifyContent: 'flex-end', gap: '16px', alignItems: 'center'}}>
            <DeleteFeedButton feed={feed} />
            <EditFeedButton feed={feed} />
            <MapperButton feed={feed} />
            <ImportButton feed={feed} />
            <ForceImportButton feed={feed} />
            <HistoryFeedButton feed={feed} />
        </div>
    );
}


export default FeedActions;
